module.exports = _.isNumber;